import { postApiCreateaccountCreateaccount } from "./postApiCreateaccountCreateaccount";
import { postApiCreateaccountIsaccountavailable } from "./postApiCreateaccountIsaccountavailable";

export function createAccountController() {
  return {
    postApiCreateaccountCreateaccount,
    postApiCreateaccountIsaccountavailable,
  };
}
